<script lang="ts">
  import { Check, ChevronDown, X } from '@lucide/svelte'
  import Button from '../../button/Button.svelte'
  import Tooltip from '../../tooltip/Tooltip.svelte'
  import {
    DropdownContainer,
    DropdownTrigger,
    DropdownContent,
    DropdownItem,
  } from '../../dropdown'
  import usePrintersQueries from '../../../routes/project/hooks/usePrintersQueries'
  import i18n from '../../../i18n'
  import { printers } from '../../../constants/printers'
  import { sceneMode } from '../../../stores/scene-mode'
  import { pendingPlacement } from '../../../stores/placement'
  import { preferredPrinter, setPreferredPrinter } from '../../../stores/preferred-printer'

  const { addPrinterMutation } = usePrintersQueries()

  let userSelectedModel = $state<PrinterModel | null>(null)
  const selectedModel = $derived(
    userSelectedModel ?? $preferredPrinter ?? printers[0].model,
  )

  const selectedOption = $derived(
    printers.find(o => o.model === selectedModel)!,
  )

  const isPlacingPrinter = $derived(
    $sceneMode === 'placement' && $pendingPlacement?.type === 'printer',
  )

  function handleClick() {
    if (isPlacingPrinter) {
      sceneMode.set('default')
    }
    else {
      setPreferredPrinter(selectedModel)
      addPrinterMutation.mutate(selectedModel)
    }
  }
</script>

<div class="container">
  <Tooltip
    placement="top"
    title={isPlacingPrinter
      ? $i18n.t('project.island.addPrinter.cancel')
      : $i18n.t('project.island.addPrinter.tooltip', {
        label: selectedOption.name,
      })}
  >
    <Button
      size="icon-sm"
      variant={isPlacingPrinter ? 'default' : 'ghost'}
      onclick={handleClick}
    >
      {#if isPlacingPrinter}
        <X />
      {:else}
        <selectedOption.addIcon />
      {/if}
    </Button>
  </Tooltip>
  <DropdownContainer>
    <DropdownTrigger disabled={isPlacingPrinter}>
      <div class="arrow">
        <ChevronDown />
      </div>
    </DropdownTrigger>
    <DropdownContent placement="top">
      {#each printers as option (option.model)}
        <DropdownItem
          onclick={() => {
            userSelectedModel = option.model
            setPreferredPrinter(option.model)
            addPrinterMutation.mutate(option.model)
          }}
        >
          <div class="dropdown-item">
            <option.icon />
            <p>{option.name}</p>
            {#if selectedModel === option.model}
              <Check />
            {/if}
          </div>
        </DropdownItem>
      {/each}
    </DropdownContent>
  </DropdownContainer>
</div>

<style lang="scss">
  .container {
    display: flex;
    align-items: center;

    .arrow {
      min-height: 2rem;
      min-width: 1rem;
      height: 2rem;
      width: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.25rem;
      background: var(--button-ghost-background);
      color: var(--button-ghost-foreground);

      &:hover {
        background: var(--button-ghost-hover-background);
        color: var(--button-ghost-hover-foreground);
      }

      :global(svg) {
        width: 0.625rem;
        height: 0.625rem;
        min-width: 0.625rem;
        min-height: 0.625rem;
      }
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;

      :global(p) {
        font-size: 0.75rem;
      }

      :global(svg) {
        width: 1rem;
        height: 1rem;
        min-width: 1rem;
        min-height: 1rem;
      }
    }
  }
</style>
